<template>
    <div :class="[has_selectors_class,template,
        'simple-page-container'
        ]" >
        <vue-scrollbar classes="content-scrollbar" ref="Scrollbar">
        <div class="content">
            <div class="special-col"></div>
            <div class="main-col">
                <h1 v-if="content_title != 'Menu'">{{ content_title }}</h1>
                <div v-html="content_text">{{ content_text }}</div>
            </div>
        </div>
        </vue-scrollbar>
    </div>
</template>

<script>
    import VueScrollbar from 'vue2-scrollbar';

    export default
    {
        components:{
            VueScrollbar
        },
        name: 'Content',
                data() {
        return {
            has_selectors_class: '',
            objects: {
                mainContentContainer: null,
                selectors: null
            }
        };
    },
        props: {
            content_text: {
                type: String,
                        required: false
            },
            content_title: {
                type: String,
                        required: false
            },
            template: {
                type: String,
                        required: false
            }
        },
        updated: function () {

            this.objects.selectors = document.querySelector('.selectors');
            
            let $images = this.objects.mainContentContainer.getElementsByTagName('img');
            let $scroll = document.querySelector('.vue-scrollbar__area');
            $scroll.classList.remove('vue-scrollbar-transition');
            this.$refs.Scrollbar.scrollToY(0);
            $scroll.style.marginTop = '0px';
            $scroll.classList.add('vue-scrollbar-transition');
            this.objects.mainContentContainer.classList.add('special-rendered-class');

            if ($images.length > 0) {
                var this_component = this;
                for (let item of $images) {
                    item.addEventListener('load', function() {
                        var content = document.querySelector('#main-content-container');
                        this_component.$emit('newImageIsLoaded', content.offsetHeight);
                        setTimeout(function() {
                            this_component.$refs.Scrollbar.calculateSize(VueScrollbar)
                        }, 400)

                    });
                }
            } else {
                this.$refs.Scrollbar.calculateSize(VueScrollbar)
            }

            this.bindSelectors();
        },
        created() {
            //console.log('created Content' );            
        },
        mounted: function() { 
            this.objects.mainContentContainer = document.querySelector('#main-content-container');
            if (this.objects.selectors == null) {
                this.objects.selectors = document.querySelector('.selectors');
            }
            /*var content = document.getElementById('main-content-container');
            //console.log('mounted Content' + content.offsetHeight);
            var this_component = this;
            $(".simple-page-container img")
                    .on('load', function() {
                        //console.log("image loaded correctly");
                        var content = document.getElementById('main-content-container');
                        //console.log('$emit refresh height ' + content.offsetHeight)
                        this_component.$emit('newImageIsLoaded', content.offsetHeight);
                    });

            /*var content = document.getElementById('main-content-container');
            //console.log('mounted Content' + content.offsetHeight);
            var this_component = this;
            let $images = document.querySelector('.simple-page-container').getElementsByTagName('img');
            if($images.length > 0) {
                for (let item of $images) {
                    item.addEventListener('load', function() {
                        //console.log("image loaded correctly");
                        var content = document.getElementById('main-content-container');
                        //console.log('$emit refresh height ' + content.offsetHeight)
                        this_component.$emit('newImageIsLoaded', content.offsetHeight);
                    });
                }
            }*/

            this.bindSelectors();
        },
        methods: {
            changeSelect(e, $selectors) {
                const $contents_to_select = document.querySelectorAll('.content-to-select');

                for (let $selector of $selectors) {
                    $selector.classList.remove('active');
                }

                for (let $content of $contents_to_select) {
                    $content.classList.remove('active');
                }

                e.target.classList.add('active');

                document.querySelector('[data-selector="' + e.target.id + '"]').classList.add('active');
                this.$refs.Scrollbar.scrollToY(0);
            },
            bindSelectors() {
                const vm = this;
                //const $selectors_g = document.querySelector('.selectors');

                if (this.objects.selectors != null) {
                    const $selectors = this.objects.selectors.getElementsByTagName('li');
                    if($selectors.length > 0) {
                        this.has_selectors_class = 'has-selectors';

                        for(let $selector of $selectors) {
                            $selector.addEventListener('click', function(e) { vm.changeSelect(e, $selectors) });
                        }                        
                    }
                } else {
                    this.has_selectors_class = '';
                }
            }
        }

    }
</script>

<style scoped lang="scss">

</style>